import axiosInstance from "./AxiosInstanceMain";

// GET ALL
export const getAllStagesApi = async (params) => {
  const res = await axiosInstance.get("/admin/stages/all", {
    params,
  });
  return res.data;
};


// CREATE
export const createStageApi = async (data) => {
  const res = await axiosInstance.post("/admin/stages/create", data);
  return res.data;
};

// UPDATE
export const updateStageApi = async (id, data) => {
  const res = await axiosInstance.put(
    `/admin/stages/update/${id}`,
    data
  );
  return res.data;
};

// TOGGLE
export const toggleStageApi = async (id) => {
  const res = await axiosInstance.patch(
    `/admin/stages/toggle/${id}`
  );
  return res.data;
};